import { z } from 'zod';

export const RoomSchema = z.object({
  id: z.string(),
  title: z.string(),
  imageUrl: z.string(),
  price: z
    .object({
      currencyCode: z.string(),
      amount: z.number(),
    })
    .optional(),
  quantity: z.optional(z.number()),
  displayUrgencyMessaging: z.optional(z.boolean()),
  unAvailable: z.boolean(),
  maxOccupancy: z.number().nullable().default(2),
  maxAdults: z.optional(z.number()).nullable(),
  maxChildren: z.optional(z.number()).nullable(),
});
